<div *ngIf="isMobile(); else desktopFacts" class="card border-1 mr-0 mr-lg-1 my-lg-3 my-sm-3 my-md-0 mb-5 bg-dark">
  <header class="card-header border-0 position-relative px-5 pt-4 pb-5 bg-dark">
    <h2 class="h4 mb-1">{{factsHeader}}:</h2>
  </header>
  <div class="card-body pt-0 px-5 pb-5">
    <ul class="list-group list-group-flush list-group-borderless">
      <li class="list-group-item py-2 bg-dark" style="font-size: 16px;">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[0]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[0]}}
        </div>
      </li>
      <li class="list-group-item bg-dark" style="font-size: 16px;">
        <div class="d-flex align-items-top">
                        <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[1]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                        </span>
          {{facts[1]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark" style="font-size: 16px;">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[2]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[2]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark" style="font-size: 16px;" *ngIf="facts[3]">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[3]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[3]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark" style="font-size: 16px;" *ngIf="facts[4]">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[4]}">
                        <app-fa-icon iconName="feather-alt"  width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[4]}}
        </div>
      </li>
    </ul>
  </div>
</div>
<ng-template #desktopFacts>
<div class="card border-1 mr-0 mr-lg-1 my-lg-3 my-sm-3 my-md-0 mb-5 bg-dark">
  <header class="card-header border-0 position-relative px-5 pt-4 pb-5 bg-dark">
    <h2 class="h4 mb-1">{{factsHeader}}:</h2>
  </header>
  <div class="card-body pt-0 px-5 pb-5" style="font-size: 16px;">
    <ul class="list-group list-group-flush list-group-borderless">
      <li class="list-group-item py-2 bg-dark">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[0]}">
                        <app-fa-icon iconName="feather-alt"  width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[0]}}
        </div>
      </li>
      <li class="list-group-item bg-dark">
        <div class="d-flex align-items-top">
                        <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[1]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                        </span>
          {{facts[1]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[2]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[2]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark" *ngIf="facts[3]">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[3]}">
                        <app-fa-icon iconName="feather-alt" width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[3]}}
        </div>
      </li>
      <li class="list-group-item py-2 bg-dark" *ngIf="facts[4]">
        <div class="d-flex align-items-top">
                      <span class="btn btn-xs btn-icon btn-soft-white rounded-circle mr-3" [ngStyle]="{'width': circleWidths[4]}">
                        <app-fa-icon iconName="feather-alt"  width="1" height="1.8"></app-fa-icon>
                      </span>
          {{facts[4]}}
        </div>
      </li>
    </ul>
  </div>
</div>
</ng-template>
